// extracted by mini-css-extract-plugin
export default {"wrap":"Toast_wrap__6hMiR","icon":"Toast_icon__PJnWN","iconImg":"Toast_iconImg__W84T9","message":"Toast_message__hxN4Z"};